export const paymentCodeOptions = [
    {
        value: 0,
        label: '未定',
        info: '',
    },
    {
        value: 21,
        label: '21',
        info: '進項三聯式、電子計算機統一發票',
    },
    {
        value: 22,
        label: '22',
        info: '進項二聯式收銀機統一發票、載有稅額之其他憑證',
    },
    {
        value: 23,
        label: '23',
        info: '三聯式、電子計算機、三聯式收銀機統一發票及一般稅額計算之電子發票之進貨退出或折讓證明單，應逐筆登錄',
    },
    {
        value: 24,
        label: '24',
        info: '二聯式收銀機統一發票及載有稅額之其他憑證之進貨退出或折讓證明單，應逐筆登錄',
    },
    {
        value: 25,
        label: '25',
        info: '進項三聯式收銀機統一發票及一般稅額計算之電子發票',
    },
];

export const invoiceCodeOptions = [
    {
        value: 0,
        label: '未定',
        info: '',
    },
    {
        value: 31,
        label: '31',
        info: '銷項三聯式',
    },
    {
        value: 32,
        label: '32',
        info: '銷項二聯式、二聯式收銀機統一發票',
    },
    {
        value: 33,
        label: '33',
        info: '三聯式、電子計算機、三聯式收銀機統一發票及一般稅額計算之電子發票之銷貨退回或折讓證明單，應逐筆登錄',
    },
    {
        value: 34,
        label: '34',
        info: '二聯式、二聯式收銀機統一發票及銷項免用統一發票之銷貨退回或折讓證明單，應逐筆登錄',
    },
    {
        value: 35,
        label: '35',
        info: '銷項一般稅額計算之電子發票、銷項三聯式收銀機統一發票',
    },
    {
        value: 36,
        label: '36',
        info: '銷項免用統一發票',
    },
];

export const statusList = [
    { value: false, label: '未申報', typ: 'invoice' },
    { value: true, label: '已申報', typ: 'invoice' },
    { value: 0, label: '未申報', typ: 'payment' },
    { value: 1, label: '已申報', typ: 'payment' },
    { value: 2, label: '不申報扣抵', typ: 'payment' },
];
